import React from "react"
import { Button, Stack } from "@mui/material"
import { BASIC_INFO_KEY } from "../../../enums/profileSetupEnums"
import LoadingButton from '@mui/lab/LoadingButton';

export const ProfileSetupButtons = (props) => {
  const {
    handleSubmit,
    currentForm,
    handleBack,
    submitText = 'Next',
    loading = false
  } = props;

  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} gap={1} justifyContent={'flex-end'} mt={4}>
      <Button
        variant="outlined"
        sx={{ width: { xs: '100%', sm: '250px' } }}
        onClick={handleBack}
      >
        {(currentForm || currentForm === BASIC_INFO_KEY) ? 'Back' : 'Cancel'}
      </Button>
      <LoadingButton
        onClick={() => handleSubmit()}
        size="small"
        loading={loading}
        variant="contained"
        disabled={loading}
        sx={{ color: '#FFF', width: { xs: '100%', sm: '250px' } }}
      >
        {submitText}
      </LoadingButton>
    </Stack>
  )
}